import React, { createContext, useContext, useMemo, useState } from "react"

const UIContext = createContext(null)

export const UIProvider = ({ children }) => {
  const [isHeaderMobileOpen, setHeaderMobileOpen] = useState(false)
  const [isDocsSidebarOpen, setDocsSidebarOpen] = useState(false)

  // Header 
  const openHeaderMenu = () => {
    setHeaderMobileOpen(true)
    setDocsSidebarOpen(false)
  }
  const closeHeaderMenu = () => setHeaderMobileOpen(false)
  const toggleHeaderMenu = () => {
    setHeaderMobileOpen(prev => {
      const next = !prev
      if (next) setDocsSidebarOpen(false)
      return next
    })
  }

  // Docs 
  const openDocsSidebar = () => {
    setDocsSidebarOpen(true)
    setHeaderMobileOpen(false)
  }
  const closeDocsSidebar = () => setDocsSidebarOpen(false)
  const toggleDocsSidebar = () => {
    setDocsSidebarOpen(prev => {
      const next = !prev
      if (next) setHeaderMobileOpen(false)
      return next
    })
  }

  const closeAll = () => {
    setHeaderMobileOpen(false)
    setDocsSidebarOpen(false)
  }

  const value = useMemo(
    () => ({
      isHeaderMobileOpen,
      isDocsSidebarOpen,
      openHeaderMenu,
      closeHeaderMenu,
      toggleHeaderMenu,
      openDocsSidebar,
      closeDocsSidebar,
      toggleDocsSidebar,
      closeAll,
    }),
    [isHeaderMobileOpen, isDocsSidebarOpen]
  )

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>
}

export const useUI = () => {
  const ctx = useContext(UIContext)
  if (!ctx) {
    throw new Error("useUI must be used within a UIProvider")
  }
  return ctx
}